import React from "react";
import {
	BooleanField,
	FunctionField,
	NumberField,
	Show,
	SimpleShowLayout,
	TextField,
} from "react-admin";

import { DateTimeField } from "../../../components/fields/DateFormatField";

import { ActionsWithBackButton } from "../../../components/actionbars/ActionsWithBackButton";
import { PriceField } from "../../../components/fields/PriceField";
import { OrderReferenceField } from "../../../components/fields/OrderReferenceField";
import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { UserFullNameReferenceField } from "../../../components/fields/UserFullNameReferenceField";
import { useUserSettingsContext } from "../../../contexts/UserSettingsProvider";
import { ChargeTypeByCode, CustomerServiceChargeType } from "../../../entities/CustomerCDChargeType";
import { plainNumber } from "../../../utils/constants";

export const CustomerArticlesShow = (props) => {
	const { data: userSettings } = useUserSettingsContext();

	const currency = userSettings?.company_settings?.currency;

	return (
		<Show actions={<ActionsWithBackButton />} {...props} title="Billing Record Details">
			<SimpleShowLayout>
				<TextField source="id" label="ID" />
				<TextField source="company_name" label="Company" />

				<NumberField source="article_code" {...plainNumber} />

				<TextField source="name" label="Article Name" />
				<TextField source="service_description" label="Service Description" />

				<NumberField source="units" label="Units" options={{ minimumFractionDigits: 2 }} />
				<BooleanField source="is_t1" />
				<OrderReferenceField source="order_id" />
				<TextField source="ceel_number" />
				<TextField source="batch_number" />
				<FunctionField
					source="article_code"
					label="resources.customer-articles.fields.charge_type"
					render={(record) => (
						<SelectEnumField
							record={{ charge_type: ChargeTypeByCode[record.article_code] }}
							source="charge_type"
							enumObj={CustomerServiceChargeType}
							enumName="cs_service_charge_type"
						/>
					)}
				/>
				{currency ? (
					<PriceField source="price" label="Unit Price" mainCurrency={currency} />
				) : (
					<NumberField
						source="price"
						label="Unit Price"
						options={{ style: "currency", currency: "NOK" }}
					/>
				)}
				{currency ? (
					<PriceField source="total_amount" label="Total Amount" mainCurrency={currency} />
				) : (
					<NumberField
						source="total_amount"
						label="Total Amount"
						options={{ style: "currency", currency: "NOK" }}
					/>
				)}

				<DateTimeField source="created_at" />
				<UserFullNameReferenceField source="created_by" />
				<DateTimeField source="updated_at" />
				<UserFullNameReferenceField source="updated_by" />

				<TextField source="color" label="Color" />
				<TextField source="calculation" label="Calculation" />
			</SimpleShowLayout>
		</Show>
	);
};
